export default {
  title: 'Webshop',
  fields: {
    has_reservations: {
      label: 'Vis reservationer på webshoppen',
    },
  },
  button: {
    save: 'Gem',
    preview: 'Eksempel',
  },
  no_storefront: {
    title: 'Ingen webshop fundet',
    description: 'Opret en webshop.',
    button: {
      storefront: 'Gå til webshop',
    },
  },
  response_messages: {
    success: 'Opdateret.',
    failed: 'Opdateringen mislykkedes.',
  },
};
